import React from "react";
import EstadisticasCanal from "./EstadisticasCanal";
export default function EstadisticasSSPP(){ return <EstadisticasCanal canal="sspp" />; }
